import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';
import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import {Navigation, Pagination} from 'swiper/modules';
import PhotoSwipeDynamicCaption from 'photoswipe-dynamic-caption-plugin';
import 'photoswipe/style.css';
import 'photoswipe-dynamic-caption-plugin/photoswipe-dynamic-caption-plugin.css';
import '../styles/photoswipe.css';

export class GalleryInline {
	private instances: Array<{
		swiper: Swiper,
		photoswipe: PhotoSwipeLightbox,
		captionPlugin: PhotoSwipeDynamicCaption,
	}> = [];

	constructor(
					private gallerySelector: string,
	) {
		this.init();
	}

	private init(): void {
		document.querySelectorAll<HTMLElement>(this.gallerySelector)
						.forEach(gallery => {
							const swiper = new Swiper(gallery, {
								modules: [Navigation, Pagination],
								slidesPerView: 'auto',
								grabCursor: true,
								//spaceBetween: 0,
								keyboard: {
									enabled: true,
								},
								navigation: {
									nextEl: gallery.querySelector<HTMLElement>('.gallery-swiper-button-next'),
									prevEl: gallery.querySelector<HTMLElement>('.gallery-swiper-button-previous'),
								},
								rewind: true,
							});

							const linkItems = gallery.querySelectorAll<HTMLAnchorElement>('.swiper-slide a');

							const photoswipe = new PhotoSwipeLightbox({
								gallery: gallery,
								children: linkItems,
								pswpModule: () => import('photoswipe')
							});

							const captionPlugin = new PhotoSwipeDynamicCaption(photoswipe, {
								// Plugins options, for example:
								type: 'auto',
							});

							photoswipe.init();

							this.instances.push({
								swiper,
								photoswipe,
								captionPlugin,
							});
						});
	}

	private tearDown(): void {
		for (const {swiper, photoswipe} of this.instances) {
			photoswipe.destroy();
			swiper.destroy();
		}

		this.instances = [];
	}
}

export let galleryInline: GalleryInline | undefined;

document.addEventListener('DOMContentLoaded', () => {
	galleryInline = new GalleryInline('.gallery-swiper');
});
